import { TOverviewCriterionStatus } from "@/zapi-frontend/stores/project";

export const SHADOW_200 =
  "shadow-[0px_51px_14px_0px_rgba(24,24,27,0),0px_33px_13px_0px_rgba(24,24,27,0),0px_18px_11px_0px_rgba(24,24,27,0.01),0px_8px_8px_0px_rgba(24,24,27,0.01),0px_2px_5px_0px_rgba(24,24,27,0.02)]";

export const criterionStatusStyle: Record<
  TOverviewCriterionStatus,
  { text: string; bg: string; dot: string; legendDot: string; border: string; card: string }
> = {
  pass: {
    text: "text-[#2B5E30]",
    bg: "bg-[#EBF2E7]",
    dot: "bg-[#489C50]",
    legendDot: "bg-[#489C50]",
    border: "border border-[#489C50]",
    card: "bg-[linear-gradient(123deg,#EBF2E7_0%,rgba(255,255,255,0)_99.94%)]"
  },
  conditional: {
    text: "text-[#B8842E]",
    bg: "bg-[#FBEFDB]",
    dot: "bg-[#B8842E]",
    legendDot: "bg-[#EEC074]",
    border: "border border-[#B8842E]",
    card: "bg-[linear-gradient(123deg,#FBEFDB_-0.06%,rgba(255,255,255,0)_100.06%)]"
  },
  fail: {
    text: "text-[#8B0C0C]",
    bg: "bg-[#FFF0F0]",
    dot: "bg-[#D93D3D]",
    legendDot: "bg-[#D93D3D]",
    border: "border border-[#8B0C0C]",
    card: "bg-[linear-gradient(123deg,#FFF0F0_0.06%,rgba(255,255,255,0)_100%)]"
  },
  unvalidated: {
    text: "text-[#3F3F46]",
    bg: "bg-[#F4F4F5]",
    dot: "bg-[#A1A1AA]",
    legendDot: "bg-[#A1A1AA]",
    border: "border border-[#D4D4D8]",
    card: "bg-[linear-gradient(123deg,#F4F4F5_0%,rgba(244,244,245,0)_99.94%)]"
  },
  not_defined: {
    text: "text-[#52525B]",
    bg: "bg-transparent",
    dot: "bg-[#D4D4D8]",
    legendDot: "bg-[#D4D4D8]",
    border: "border border-[#E4E4E7]",
    card: `bg-white border border-innoveraZinc-150 ${SHADOW_200}`
  }
};

export const STATUS_ORDER: TOverviewCriterionStatus[] = ["pass", "conditional", "fail", "unvalidated", "not_defined"];
